import { FormValues, Gender, Type } from './Checkout.interface';

export const InitialCheckoutFormValues: FormValues = {
  type: Type.EMPTY,
  caretaker: {
    gender: Gender.EMPTY,
    firstName: '',
    lastNamePrefix: '',
    lastName: '',
    email: '',
    mobile: '',
  },
  pupil: {
    gender: Gender.EMPTY,
    firstName: '',
    lastNamePrefix: '',
    lastName: '',
    email: '',
    mobile: '',
  },
  donation: {
    target: '',
    amount: '',
  },
  address: {
    postalCode: '',
    houseNumber: '',
    houseNumberSuffix: '',
    street: '',
    city: '',
  },
  invoice: {
    company: '',
    contact: '',
    postalCode: '',
    houseNumber: '',
    houseNumberSuffix: '',
    street: '',
    city: '',
    email: '',
  },
  total: {
    amountDiscount: '0.00',
    amountSubTotal: '0.00',
    amountTotal: '0.00',
    discountApplied: false,
    appliedCode: '',
  },
  school: '',
  couponCode: '',
  newsletter: false,
  terms: false,
};
